import 'bootstrap/dist/css/bootstrap.css';
import * as React from 'react';
import ConnectionContext from '../utils/ConnectionContext';
import { NavMenu } from './NavMenu';

export interface IProps {
    connectionContext: ConnectionContext;
    isAuthenticated: boolean;
    email: string;
}
export interface IState {

}
export default class Layout extends React.Component<IProps, IState> {
    static displayName = Layout.name;
    private connectionContext: ConnectionContext;
    constructor(props: IProps, state: IState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
    }
    render() {
        return (
            <div>
                <div>
                    <NavMenu isAuthenticated={this.props.isAuthenticated} connectionContext={this.connectionContext} email={this.props.email} />
                </div>
                <div>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
